/* unplugin-vue-components disabled */import script from "./Xwzx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Xwzx.vue?vue&type=script&lang=ts&setup=true"

import "./Xwzx.vue?vue&type=style&index=0&id=8954680a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8954680a"]])

export default __exports__